import React from 'react';

interface ViewHeaderProps {
  /** One short line saying what question this view answers. Copy lives in `uiConstants`. */
  purpose: string;
}

/**
 * Shared header for Insights and Diagnostics lenses: the view's purpose line.
 * Scope is shown by the workspace breadcrumb above, which also moves the
 * tree selection up a level when a crumb is clicked.
 */
const ViewHeader: React.FC<ViewHeaderProps> = ({ purpose }) => (
  <p className="text-sm text-gray-dark">{purpose}</p>
);

export default ViewHeader;
